import { createBillingGatewayFromPolicies } from "./billing/BillingGateway";
import { Policies } from "./Policies";

class School {
  constructor(data) {
    this.$originalData = data;
    const { id, name, organisation_id, policies } = data;
    this.$id = id;
    this.$name = name;
    this.$organisation_id = organisation_id;

    const policyData = policies || [];
    this.$policies = new Policies(policyData).setSchool(this);
  }

  /**
   * @returns {string}
   */
  name() {
    return this.$name;
  }

  /**
   * @returns {number}
   */
  id() {
    this.$id;
  }

  /**
   * @return {Policies}
   */
  policies() {
    return this.$policies;
  }

  /**
   * @returns {BillingGateway}
   */
  billingGatway() {
    return createBillingGatewayFromPolicies(this.policies());
  }

  /**
   * @param {Policies} policies
   */
  setPolicies(policies) {
    this.$policies = policies;
  }
}

export { School };
